import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Colors from "../../constants/Colors";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import ClearIcon from "@material-ui/icons/Clear";
import Fab from "@material-ui/core/Fab";

import AddIcon from "@material-ui/icons/Add";

import NoteIcon from "@material-ui/icons/Assignment";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { modifyPrivateActionRequest } from "../../services/action/actions";
import moment from "moment";
import Avatar from "../Team/Avatar";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { Typography } from "@material-ui/core";
import EditableInput from "../../components/EditableInput";

moment.locale("fr");

const styles = theme => ({
  closeButton: {
    zIndex: 10,
    position: "absolute",
    top: 1,
    right: 1
  },
  minDiv: {
    // width: 300,
    // minWidth: 100
  },
  accent: {
    color: "#6198DE"
  },
  commentDiv: {
    width: "100%",
    borderRadius: 8,
    border: "solid",
    borderWidth: 1,
    borderColor: Colors.lightGrey,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 15
  },
  date: {
    textAlign: "right",
    fontSize: 12
  },
  commentMainDiv: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    flexDirection: "row"
  },
  actionsButtonDiv: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  deleteButton: {
    padding: 1
  },
  editButton: {
    padding: 1,
    marginRight: -3
  },
  commentBottom: {
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
    display: "flex"
  },
  leftDiv: {
    flex: 2,
    flexWrap: "wrap",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly"
  },
  rightDiv: {
    flex: 3,
    height: 400,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  mainDiv: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
  },
  paper: {
    minWidth: "30%",
    maxWidth: "50%"
    // maxWidth: 1200
  },
  addOptionButton: {
    marginTop: 10
  },
  saveButton: {
    marginTop: 35
  },
  answerSeparatorText: {
    color: Colors.blackGrey,
    fontWeight: "bold",
    whiteSpace: "nowrap",
    marginLeft: 10,
    marginRight: 10
  },
  separator: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row"
  },
  line: {
    width: "100%",
    borderRadius: 8,
    height: 2,
    backgroundColor: Colors.blackGrey
  },
  errorText: {
    color: "#e6525a",
    padding: "13px 15px",
    borderRadius: 6,
    backgroundColor: "rgba(230,82,90,0.15)"
  },
  formControl: {
    marginTop: 16,
    marginBottom: 8,
    minWidth: 120
  }
});

class CreationModal extends Component {
  state = {
    open: false,
    error: "",
    why: "",
    how: "",
    title: "",
    titleError: "",
    actionId: "",
    category: ""
  };

  _handleKeyDown = event => {
    if (
      (window.navigator.platform.match("Mac")
        ? event.metaKey
        : event.ctrlKey) &&
      event.keyCode == 83
    ) {
      event.preventDefault();
      this.saveAction();
    }
  };

  formatDate = date => {
    return moment(date).format("L");
  };

  onRendered = () => {
    this.setState({ ...this.props.actionSelected });
    // document.addEventListener("keydown", this._handleKeyDown, false);
  };

  handleClose = onClose => () => {
    // document.removeEventListener("keydown", this._handleKeyDown, false);
    onClose();
  };

  onEditTitle = event => {
    if (this.state.titleError) {
      this.setState({ titleError: "" });
    }
    const value = event.target.value;
    this.props.changeTitle(value);
  };

  handleCategoryChange = event => {
    const value = event.target.value;
    this.setState({
      category: value
    });
  };

  handleChange = name => value => {
    // prevent bug from plugin to apply style="" in the HTML
    const newValue = value.replace(/ style="(.*?)"/gm, "");
    this.setState({ [name]: newValue });
  };

  onEditText = event => {
    const value = event.target.value;
    this.props.changeField({ notificationText: value });
  };

  saveAction = () => {
    this.setState({ error: "" });
    const { _id, title, why, how, category } = this.state;
    this.props.modifyPrivateActionRequest({
      actionId: _id,
      title,
      why,
      how,
      category
    });
  };

  render() {
    const { classes, isVisible, onClose } = this.props;
    return (
      <Dialog
        open={isVisible}
        onRendered={this.onRendered}
        onClose={this.handleClose(onClose)}
        classes={{ paper: classes.paper }}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
      >
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <DialogTitle id="scroll-dialog-title">Modifier une action</DialogTitle>
        <DialogContent>
          <div className={classes.mainDiv}>
            <p className={classes.label}>Titre de l'action</p>
            <EditableInput
              text={this.state.title}
              placeholder={"Titre de l'action"}
              onChange={this.handleChange("title")}
            />
            <p className={classes.label}>Pourquoi ?</p>
            <EditableInput
              text={this.state.why}
              placeholder={"Pourquoi ?"}
              onChange={this.handleChange("why")}
            />
            <p className={classes.label}>Exemples concrets</p>
            <EditableInput
              text={this.state.how}
              placeholder={"Exemples concrets"}
              onChange={this.handleChange("how")}
            />
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                ref={ref => {
                  this.InputLabelRef = ref;
                }}
                htmlFor="outlined-age-native-simple"
              >
                Catégorie
              </InputLabel>
              <Select
                native
                value={this.state.category}
                onChange={this.handleCategoryChange}
                input={
                  <OutlinedInput
                    name="Catégorie"
                    labelWidth={this.state.labelWidth}
                    id="outlined-age-native-simple"
                  />
                }
              >
                <option value={"leadership"}>Leadership</option>
                <option value={"teamCohesion"}>Cohésion d'équipe</option>
                <option value={"proactivity"}>Pro-activité</option>
                <option value={"resilience"}>Résilience</option>
                <option value={"publicSpeaking"}>Capacité à convaincre</option>
              </Select>
            </FormControl>

            {this.state.error && (
              <p className={classes.errorText}>{this.state.error}</p>
            )}
            {this.props.requesting ? (
              <CircularProgress />
            ) : (
              <Button
                className={classes.saveButton}
                fullWidth
                onClick={this.saveAction}
                variant="contained"
                color="primary"
              >
                Sauvegarder les changements
              </Button>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const { requesting } = state.action;
  const { userId } = state.client;
  const { managerTeam } = state.manager;
  return {
    userId,
    requesting,
    managerTeam
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {
      modifyPrivateActionRequest
    }
  )(CreationModal)
);
